import React from 'react'
import actions from 'redux/actions'
import { constants } from 'common/helpers'
import { useCallback, useQuery } from 'sb-hooks'

import { Box } from 'components/_new/layout'
import Modal from 'components/modal/Modal/Modal'
import { Button } from 'components/_new/controls'
import { ContentWithLoader } from 'components/_new/ui'

import Product from './Product/Product'
import detailsProductQuery from './detailsProductQuery.graphql'

import messages from './messages'
import s from './NewProductDetailsModal.scss'


type NewProductDetailsModalProps = {
  name: string
  data: {
    productId: number
    onClick: (data: any) => void
  }
}

const NewProductDetailsModal: React.FunctionComponent<NewProductDetailsModalProps> = (props) => {
  const { name, data: { productId, onClick } } = props

  const { data, isFetching } = useQuery(detailsProductQuery, {
    name: 'detailsProduct',
    variables: { productId },
  })

  const closeModal = useCallback(() => {
    actions.models.modals.close(name)
  }, [ name ])

  const handleButtonClick = () => {
    if (typeof onClick === 'function') {
      onClick(data)
    }

    closeModal()
  }

  return (
    <Modal name={name} onClose={closeModal}>
      <Box pt={16} pb={96}>
        <ContentWithLoader isFetching={isFetching}>
          {
            Boolean(data) && (
              <Product data={data.product} />
            )
          }
          <Box className={s.buttonContainer} pl={16} pr={16}>
            <Button
              title={messages.buttonTitle}
              rightIcon="rightArrowSmall"
              color="brand"
              size="md"
              fullWidth
              onClick={handleButtonClick}
            />
          </Box>
        </ContentWithLoader>
      </Box>
    </Modal>
  )
}


NewProductDetailsModal.defaultProps = {
  name: constants.modals.NewProductDetails,
}


export default NewProductDetailsModal
